import { useState } from "react";
import { FaPlus } from 'react-icons/fa'

import ModalButton from "./ModalButton";
import ModalWindow from "./ModalWindow";
const AddItem = ({addItem, title, prompts}) => {
    const initPrompts = () =>{
        let toReturn = []
        for(var index = 0; index < prompts.length; index++){
            toReturn.push('')
        }
        return toReturn
    }
    const processPromptItemsState = ()=>{
        let jsonString = '{'
        for(var index = 0; index < prompts.length; index++){
            jsonString += `"${prompts[index].varName}":"${promptItems[index]}"`
            if(index !== prompts.length -1){
                jsonString += ','
            }
        }
        jsonString += '}'
        return JSON.parse(jsonString)
    }
    const [promptItems, setPrompts] = useState(initPrompts())
    const onSubmit = (e) =>{
        e.preventDefault();
        addItem(processPromptItemsState());
        setPrompts(initPrompts());
    }
    return (
        <>
            <ModalButton element={(<FaPlus />)} modalId='addItemModal' className="row text-center" />
            <ModalWindow 
                id="addItemModal" 
                onSubmit={onSubmit} 
                onClose={() =>{setPrompts(initPrompts())}}
                title={title}
                submitButtonMsg="Save changes"
                element={(
                    <>
                    {prompts.map((prom, index)=>{
                        return (<div className={prom.type === 'checkbox' ? "mb-3 form-check":'mb-3'} key={index}>
                                <label htmlFor={`${prom.varName}`} className={prom.type === 'checkbox' ? 'form-check-label' : 'form-label'}>{prom.prompt}</label>
                                <input onChange={(e) => {
                                    if(prom.type === 'checkbox'){
                                        setPrompts(promptItems.map(((value,innnerIndex)=>{
                                            if(index === innnerIndex){
                                                return e.currentTarget.checked
                                            }
                                            return value
                                        })))
                                    }else{
                                        setPrompts(promptItems.map(((value,innnerIndex)=>{
                                            if(index === innnerIndex){
                                                return e.target.value
                                            }
                                            return value
                                        })))
                                    }
                                }} value={promptItems[index]} className={prom.type === 'checkbox' ? 'form-check-input' : 'form-control'} type={prom.type} name={`${prom.varName}`} id="" />
                            </div>)
                        })
                    }
                    </>
                )}
            />
        </>
    )
}

export default AddItem